module.exports = " <div id=app> <i-header></i-header> <div class=main :style=\"{ minHeight: fullHeight+'px' }\"> <router-view keep-alive></router-view> </div> <school-select :visible=!school></school-select> <i-footer></i-footer> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 774
// module chunks = 34